module.exports = __webpack_public_path__ + "static/media/Flaticon.16f8d444.woff";